export interface IPatientCoverage {
    ins_order?: number,
    tin?: string,
    insured_id?: string,
    insured_name?: string;
    insured_first_name?: string,
    insured_last_name?: string,
    insured_address?: string,
    insured_relation_to_patient?: string,
    insured_dob?: string,
    insurance_company_id?: string,
    insurance_company_name?: string,
    insurance_company_address?: string,
    insurance_company_phone_number?: string,
    group_number?: string,
    group_name?: string,
    insured_group_employer_id?: string,
    insured_group_employer_name?: string,
    insurance_carrier?: string,
    insurance_holder_name?: string,
    insurance_policy_number?: string,
    insurance_plan_id?: string,
    plan_type?: string,
    plan_effective_date?: string | DateObject,
    plan_expiration_date?: string | DateObject,
    identifier?: string,
    alternate_id?: string,
  }
  export function setCoverageValues(patientCoverage: IPatientCoverage): IPatientCoverage {
    patientCoverage.ins_order = 1;
    patientCoverage.tin = '';
    patientCoverage.insured_id = '';
    patientCoverage.insured_first_name = '';
    patientCoverage.insured_last_name = '';
    patientCoverage.insured_relation_to_patient = '';
    patientCoverage.insured_address = '';
    patientCoverage.insured_dob = null;
    patientCoverage.insurance_plan_id = '';
    patientCoverage.insurance_company_address = '';
    patientCoverage.insurance_company_phone_number = '';
    patientCoverage.group_name = '';
    patientCoverage.insured_group_employer_id = '';
    patientCoverage.insured_group_employer_name = '';
    patientCoverage.plan_effective_date = '';
    patientCoverage.plan_expiration_date = '';
    patientCoverage.plan_type = '';
    patientCoverage.insurance_carrier = '';
    patientCoverage.insurance_holder_name = '';
    patientCoverage.insurance_policy_number = '';
    patientCoverage.insurance_company_id = '';
    patientCoverage.insurance_company_name = '';
    patientCoverage.group_number = '';
    patientCoverage.group_name = '';
    patientCoverage.identifier = '';
    patientCoverage.alternate_id = '';
    return patientCoverage;
  }
  
  interface DateObject {
    year: number | string,
    month: number | string,
    day: number | string,
  }
  